import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION3: PdfComponent = {
  type: 'section',
  id: 's3',
  title: '3. Appointment and Scope',
  content: [
    {
      type: 'bulletList',
      id: 's3bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Subscriber acknowledges and agrees that Kanda may carry out identity and credit checks on the Subscriber to verify information provided by the Subscriber. Kanda may repeat such checks on renewal of the Agreement at the end of the Initial Term or any Extension Period. Kanda may terminate this Agreement in accordance with clause 2.3 on the basis of the results of such identity or credit checks.',
        },
      ],
      prefix: '3',
    },
  ],
};
